import { Alert, Container, Snackbar, styled, Typography } from '@mui/material';
import { useState } from 'react';
import FeatureFlagsTable from '../../components/FeatureFlagManagement/FeatureFlagsTable';

const TextWrapper = styled('div')({
  gridColumn: '1/5',
});

function FeatureFlagManagement() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const handleSnackbarClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Container sx={{ marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Manage feature flags
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            Enable/disable feature flags for the application. Use the actions menu to manage visibility by county, team
            or user for each feature flag.
          </Typography>
        </TextWrapper>
        <FeatureFlagsTable snackbarData={showSnackbar} />
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default FeatureFlagManagement;
